import { connect } from 'react-redux';

import VideoDashboard from './VideoDashboard';

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {})(VideoDashboard);
